module.exports = "<div id=\"non-responsive-squishy-page-id\">\r\n\t<app-non-responsive-squishy></app-non-responsive-squishy>\r\n</div>\r\n"